export default __webpack_public_path__ + "static/media/background-login-top.63a60f77.svg";